import {
  ApiResponse,
  CompanyDetailReviewCategory,
  UserReports
} from "@/api/types";

export interface UserReportsWithName extends UserReports {
  name: string;
}

export interface ReviewRating {
  rating_ave?: string;
  rating1: string;
  rating2: string;
  rating3: string;
  rating4: string;
  rating5: string;
  rating6: string;
}

export type Genre = keyof Omit<ReviewRating, "rating_ave">;

export const ReviewRatingIntern: ReviewRating = {
  rating1: "業界・事業の魅力",
  rating2: "社風・人の魅力",
  rating3: "自己成長度",
  rating4: "参加学生のレベル",
  rating5: "選考の難易度",
  rating6: "本選考への影響度"
};

export const ReviewRatingRecruitment: ReviewRating = {
  rating1: "業界・事業の魅力",
  rating2: "社風・人の魅力",
  rating3: "仕事内容・キャリアの魅力",
  rating4: "働く環境の魅力",
  rating5: "待遇の魅力",
  rating6: "本選考の難易度"
};

export const ReviewRatingSeminar: ReviewRating = {
  rating1: "社風・人の魅力",
  rating2: "業界・事業の理解度",
  rating3: "参加学生のレベル",
  rating4: "採用・選考情報の理解度",
  rating5: "仕事内容・キャリアの魅力",
  rating6: "働く環境の魅力"
};

export interface ContainerProps {}

export interface ContainerData {
  loading: {
    page: boolean;
    follow: boolean;
  };
  company?: ApiResponse.CompanyDetail;
  review: UserReportsWithName[];
}

export interface ContainerComputed {
  partnerUser?: ApiResponse.PartnerUser;
  isOurCompany: boolean;
}

export interface ContainerMethods {
  getCompanySummary: () => void;
  reviewShaping: (review: UserReports[]) => UserReportsWithName[];
  handleClickFollow: (isFollow: boolean) => void;
}

export interface Data {
  activeTab: number;
}

export interface Computed {}

export interface Props {
  loading: {
    page: boolean;
    follow: boolean;
  };
  isOurCompany: ContainerComputed["isOurCompany"];
  company: ApiResponse.CompanyDetail;
  review: UserReportsWithName[];
}
export interface Methods {
  reviewCount: (index: number) => number;
  reviewLabel: (index: number) => string;
  tabState: (index: number, category: CompanyDetailReviewCategory) => boolean;
  clickTab: () => void;
  handleClickFollow: (data: { isFollow: boolean }) => void;
}
